export default [
    {
        path: "/ipft-escape-users",
        component: () => import("../Components/List.vue"),
        name: "ipft-escape-users-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/ipft-escape-users-update",
        component: () => import("../Components/IpftEscapeUpdate.vue"),
        name: "ipft-escape-users-update",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/ipft-users/:id/edit",
        component: () => import("../Components/Edit.vue"),
        name: "ipft-users-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/ipft-users/create",
        component: () => import("../Components/Create.vue"),
        name: "ipft-users-create",
        meta: {
            requiresAuth: true,
        },
    },
];
